import React, { Component } from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';
import { isDev } from 'common/utils';
import { Responsive } from 'common/components';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: oneOfType([arrayOf(node), node]),
  };

  state = { error: null };

  render() {
    if (!isDev() && window && window.Raven && this.state.error) {
      const Raven = window.Raven;
      // render fallback UI
      return (
        <div className="container">
          <div className="columns">
            <div className="column">
              <h1>Oops.</h1>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <p>
                We&apos;re sorry — something&apos;s gone wrong. Our team has
                been notified. Click the button below to fill out a report.
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <button
                className="button btn btn--secondary btn--add"
                type="button"
                onClick={() => Raven.lastEventId() && Raven.showReportDialog()}
              >
                <Responsive.Desktop>Report an issue.</Responsive.Desktop>
              </button>
            </div>
          </div>
        </div>
      );
    }
    // when there's not an error, render children untouched
    return this.props.children;
  }

  componentDidCatch(error, errorInfo) {
    if (!isDev() && window && window.Raven) {
      const Raven = window.Raven;
      Raven.captureException(error, { extra: errorInfo });
      this.setState({ error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ErrorBoundary/index.js